// Generated from .\customExpression.g4 by ANTLR 4.7.2
// jshint ignore: start
import antlr4 from '../../utils/interop/antlr4';
import { customExpressionVisitor } from './customExpressionVisitor';

var grammarFileName = 'customExpression.g4';

var serializedATN = [
  '\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964',
  '\u0003#\u00fb\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004\t',
  '\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t\u0007\u0004',
  '\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004\f\t\f\u0004',
  '\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010\t\u0010\u0004',
  '\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013\u0004\u0014\t',
  '\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017\t\u0017\u0004',
  '\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a\u0004\u001b\t',
  '\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e\t\u001e\u0004',
  '\u001f\t\u001f\u0004 \t \u0003\u0002\u0003\u0002\u0005\u0002C\n\u0002',
  '\u0003\u0002\u0003\u0002\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003',
  '\u0003\u0003\u0005\u0003L\n\u0003\u0003\u0004\u0003\u0004\u0005\u0004',
  'P\n\u0004\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0005',
  '\u0005\u0005W\n\u0005\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006',
  '\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0005\u0006',
  'b\n\u0006\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\b\u0003',
  '\b\u0003\b\u0003\b\u0003\b\u0003\b\u0005\bn\n\b\u0003\t\u0003\t\u0005',
  '\tr\n\t\u0003\n\u0003\n\u0003\n\u0003\n\u0005\nx\n\n\u0003\u000b\u0003',
  '\u000b\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\r\u0003\r\u0003',
  '\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\u000e\u0003',
  '\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003',
  '\u000f\u0003\u000f\u0003\u000f\u0003\u000f\u0003\u000f\u0003\u0010\u0003',
  '\u0010\u0003\u0010\u0003\u0010\u0003\u0010\u0003\u0010\u0003\u0010\u0003',
  '\u0010\u0003\u0010\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003',
  '\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0012\u0003',
  '\u0012\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0012\u0003',
  '\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003',
  '\u0013\u0003\u0013\u0003\u0013\u0003\u0014\u0003\u0014\u0003\u0014\u0003',
  '\u0014\u0003\u0015\u0003\u0015\u0003\u0015\u0003\u0015\u0003\u0015\u0003',
  '\u0015\u0003\u0015\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0016\u0003',
  '\u0016\u0003\u0016\u0003\u0016\u0003\u0017\u0003\u0017\u0003\u0017\u0003',
  '\u0017\u0003\u0017\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0018\u0003',
  '\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003',
  '\u0019\u0003\u0019\u0003\u0019\u0003\u001a\u0003\u001a\u0003\u001a\u0003',
  '\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0005\u001a\u00e3\n\u001a',
  '\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b',
  '\u0003\u001b\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c',
  '\u0003\u001c\u0003\u001c\u0003\u001d\u0003\u001d\u0003\u001e\u0003\u001e',
  '\u0003\u001f\u0003\u001f\u0003 \u0003 \u0003 \u0002\u0002!\u0002\u0004',
  '\u0006\b\n\f\u000e\u0010\u0012\u0014\u0016\u0018\u001a\u001c\u001e ',
  '"$&(*,.02468:<>\u0002\u0007\u0003\u0002\u0006\u0007\u0003\u0002\r\u000e',
  '\u0003\u0002\u0011\u0012\u0003\u0002\u0018\u0019\u0003\u0002\u001a\u001d',
  '\u0002\u00f8\u0002B\u0003\u0002\u0002\u0002\u0004K\u0003\u0002\u0002',
  '\u0002\u0006O\u0003\u0002\u0002\u0002\bV\u0003\u0002\u0002\u0002\na',
  '\u0003\u0002\u0002\u0002\fc\u0003\u0002\u0002\u0002\u000em\u0003\u0002',
  '\u0002\u0002\u0010q\u0003\u0002\u0002\u0002\u0012w\u0003\u0002\u0002',
  '\u0002\u0014y\u0003\u0002\u0002\u0002\u0016{\u0003\u0002\u0002\u0002',
  '\u0018\u0080\u0003\u0002\u0002\u0002\u001a\u0089\u0003\u0002\u0002\u0002',
  '\u001c\u0090\u0003\u0002\u0002\u0002\u001e\u0095\u0003\u0002\u0002\u0002',
  ' \u009e\u0003\u0002\u0002\u0002"\u00a7\u0003\u0002\u0002\u0002$\u00ae',
  '\u0003\u0002\u0002\u0002&\u00b7\u0003\u0002\u0002\u0002(\u00bb\u0003',
  '\u0002\u0002\u0002*\u00c2\u0003\u0002\u0002\u0002,\u00c9\u0003\u0002',
  '\u0002\u0002.\u00ce\u0003\u0002\u0002\u00020\u00d2\u0003\u0002\u0002',
  '\u00022\u00e2\u0003\u0002\u0002\u00024\u00e4\u0003\u0002\u0002\u0002',
  '6\u00eb\u0003\u0002\u0002\u00028\u00f2\u0003\u0002\u0002\u0002:\u00f4',
  '\u0003\u0002\u0002\u0002<\u00f6\u0003\u0002\u0002\u0002>\u00f8\u0003',
  '\u0002\u0002\u0002@C\u0005\u0004\u0003\u0002AC\u00052\u001a\u0002B@',
  '\u0003\u0002\u0002\u0002BA\u0003\u0002\u0002\u0002CD\u0003\u0002\u0002',
  '\u0002DE\u0007\u0002\u0002\u0003E\u0003\u0003\u0002\u0002\u0002FL\u0005',
  '.\u0018\u0002GL\u00050\u0019\u0002HL\u0005\u0006\u0004\u0002IL\u0005',
  '\u000e\b\u0002JL\u0005\u0012\n\u0002KF\u0003\u0002\u0002\u0002KG\u0003',
  '\u0002\u0002\u0002KH\u0003\u0002\u0002\u0002KI\u0003\u0002\u0002\u0002',
  'KJ\u0003\u0002\u0002\u0002L\u0005\u0003\u0002\u0002\u0002MP\u0005\b',
  '\u0005\u0002NP\u0005\f\u0007\u0002OM\u0003\u0002\u0002\u0002ON\u0003',
  '\u0002\u0002\u0002P\u0007\u0003\u0002\u0002\u0002QW\u0005> \u0002RW',
  '\u0005\n\u0006\u0002SW\u00058\u001d\u0002TW\u00050\u0019\u0002UW\u0005',
  '.\u0018\u0002VQ\u0003\u0002\u0002\u0002VR\u0003\u0002\u0002\u0002VS',
  '\u0003\u0002\u0002\u0002VT\u0003\u0002\u0002\u0002VU\u0003\u0002\u0002',
  '\u0002W\t\u0003\u0002\u0002\u0002Xb\u0005\u0016\f\u0002Yb\u0005\u0018',
  '\r\u0002Zb\u0005\u001a\u000e\u0002[b\u0005\u001c\u000f\u0002\\b\u0005',
  '\u001e\u0010\u0002]b\u0005 \u0011\u0002^b\u0005"\u0012\u0002_b\u0005',
  '$\u0013\u0002`b\u0005&\u0014\u0002aX\u0003\u0002\u0002\u0002aY\u0003',
  '\u0002\u0002\u0002aZ\u0003\u0002\u0002\u0002a[\u0003\u0002\u0002\u0002',
  'a\\\u0003\u0002\u0002\u0002a]\u0003\u0002\u0002\u0002a^\u0003\u0002',
  '\u0002\u0002a_\u0003\u0002\u0002\u0002a`\u0003\u0002\u0002\u0002b\u000b',
  '\u0003\u0002\u0002\u0002cd\u0005\b\u0005\u0002de\u0007\u0003\u0002\u0002',
  'ef\u0005\u0006\u0004\u0002f\r\u0003\u0002\u0002\u0002gn\u0005:\u001e',
  '\u0002hn\u0005<\u001f\u0002in\u0005\u0010\t\u0002jn\u00058\u001d\u0002',
  'kn\u00050\u0019\u0002ln\u0005.\u0018\u0002mg\u0003\u0002\u0002\u0002',
  'mh\u0003\u0002\u0002\u0002mi\u0003\u0002\u0002\u0002mj\u0003\u0002\u0002',
  '\u0002mk\u0003\u0002\u0002\u0002ml\u0003\u0002\u0002\u0002n\u000f\u0003',
  '\u0002\u0002\u0002or\u0005(\u0015\u0002pr\u0005*\u0016\u0002qo\u0003',
  '\u0002\u0002\u0002qp\u0003\u0002\u0002\u0002r\u0011\u0003\u0002\u0002',
  '\u0002sx\u0005\u0014\u000b\u0002tx\u00058\u001d\u0002ux\u00050\u0019',
  '\u0002vx\u0005.\u0018\u0002ws\u0003\u0002\u0002\u0002wt\u0003\u0002',
  '\u0002\u0002wu\u0003\u0002\u0002\u0002wv\u0003\u0002\u0002\u0002x\u0013',
  '\u0003\u0002\u0002\u0002yz\u0005,\u0017\u0002z\u0015\u0003\u0002\u0002',
  '\u0002{|\u0007\u001f\u0002\u0002|}\u0007\u0004\u0002\u0002}~\u0005\u0006',
  '\u0004\u0002~\u007f\u0007\u0005\u0002\u0002\u007f\u0017\u0003\u0002',
  '\u0002\u0002\u0080\u0081\t\u0002\u0002\u0002\u0081\u0082\u0007\u0004',
  '\u0002\u0002\u0082\u0083\u0005\u0006\u0004\u0002\u0083\u0084\u0007\b',
  '\u0002\u0002\u0084\u0085\u0005\u000e\b\u0002\u0085\u0086\u0007\b\u0002',
  '\u0002\u0086\u0087\u0005\u0006\u0004\u0002\u0087\u0088\u0007\u0005\u0002',
  '\u0002\u0088\u0019\u0003\u0002\u0002\u0002\u0089\u008a\u0007\t\u0002',
  '\u0002\u008a\u008b\u0007\u0004\u0002\u0002\u008b\u008c\u0005\u0006\u0004',
  '\u0002\u008c\u008d\u0007\b\u0002\u0002\u008d\u008e\u0005\u0006\u0004',
  '\u0002\u008e\u008f\u0007\u0005\u0002\u0002\u008f\u001b\u0003\u0002\u0002',
  '\u0002\u0090\u0091\u0007\n\u0002\u0002\u0091\u0092\u0007\u0004\u0002',
  '\u0002\u0092\u0093\u0005\u0012\n\u0002\u0093\u0094\u0007\u0005\u0002',
  '\u0002\u0094\u001d\u0003\u0002\u0002\u0002\u0095\u0096\u0007\u000b\u0002',
  '\u0002\u0096\u0097\u0007\u0004\u0002\u0002\u0097\u0098\u0005\u0006\u0004',
  '\u0002\u0098\u0099\u0007\b\u0002\u0002\u0099\u009a\u0005\u0006\u0004',
  '\u0002\u009a\u009b\u0007\b\u0002\u0002\u009b\u009c\u0005\u0006\u0004',
  '\u0002\u009c\u009d\u0007\u0005\u0002\u0002\u009d\u001f\u0003\u0002\u0002',
  '\u0002\u009e\u009f\u0007\f\u0002\u0002\u009f\u00a0\u0007\u0004\u0002',
  '\u0002\u00a0\u00a1\u0005\u0006\u0004\u0002\u00a1\u00a2\u0007\b\u0002',
  '\u0002\u00a2\u00a3\u0005\u000e\b\u0002\u00a3\u00a4\u0007\b\u0002\u0002',
  '\u00a4\u00a5\u0005\u0006\u0004\u0002\u00a5\u00a6\u0007\u0005\u0002\u0002',
  '\u00a6!\u0003\u0002\u0002\u0002\u00a7\u00a8\t\u0003\u0002\u0002\u00a8',
  '\u00a9\u0007\u0004\u0002\u0002\u00a9\u00aa\u0005\u0006\u0004\u0002\u00aa',
  '\u00ab\u0007\b\u0002\u0002\u00ab\u00ac\u0005\u000e\b\u0002\u00ac\u00ad',
  '\u0007\u0005\u0002\u0002\u00ad#\u0003\u0002\u0002\u0002\u00ae\u00af',
  '\u0007\u000f\u0002\u0002\u00af\u00b0\u0007\u0004\u0002\u0002\u00b0\u00b1',
  '\u0005\u0006\u0004\u0002\u00b1\u00b2\u0007\b\u0002\u0002\u00b2\u00b3',
  '\u0005\u000e\b\u0002\u00b3\u00b4\u0007\b\u0002\u0002\u00b4\u00b5\u0005',
  '\u000e\b\u0002\u00b5\u00b6\u0007\u0005\u0002\u0002\u00b6%\u0003\u0002',
  '\u0002\u0002\u00b7\u00b8\u0007\u0010\u0002\u0002\u00b8\u00b9\u0007\u0004',
  "\u0002\u0002\u00b9\u00ba\u0007\u0005\u0002\u0002\u00ba\'\u0003\u0002",
  '\u0002\u0002\u00bb\u00bc\t\u0004\u0002\u0002\u00bc\u00bd\u0007\u0004',
  '\u0002\u0002\u00bd\u00be\u0005\u000e\b\u0002\u00be\u00bf\u0007\b\u0002',
  '\u0002\u00bf\u00c0\u0005\u000e\b\u0002\u00c0\u00c1\u0007\u0005\u0002',
  '\u0002\u00c1)\u0003\u0002\u0002\u0002\u00c2\u00c3\u0007\u0013\u0002',
  '\u0002\u00c3\u00c4\u0007\u0004\u0002\u0002\u00c4\u00c5\u0005\u000e\b',
  '\u0002\u00c5\u00c6\u0007\b\u0002\u0002\u00c6\u00c7\u0005\u000e\b\u0002',
  '\u00c7\u00c8\u0007\u0005\u0002\u0002\u00c8+\u0003\u0002\u0002\u0002',
  '\u00c9\u00ca\u0007\u0014\u0002\u0002\u00ca\u00cb\u0007\u0004\u0002\u0002',
  '\u00cb\u00cc\u0005\u0006\u0004\u0002\u00cc\u00cd\u0007\u0005\u0002\u0002',
  '\u00cd-\u0003\u0002\u0002\u0002\u00ce\u00cf\u0007\u0015\u0002\u0002',
  '\u00cf\u00d0\u0007\u0004\u0002\u0002\u00d0\u00d1\u0007\u0005\u0002\u0002',
  '\u00d1/\u0003\u0002\u0002\u0002\u00d2\u00d3\u0007\u0016\u0002\u0002',
  '\u00d3\u00d4\u0007\u0004\u0002\u0002\u00d4\u00d5\u00052\u001a\u0002',
  '\u00d5\u00d6\u0007\b\u0002\u0002\u00d6\u00d7\u0005\u0004\u0003\u0002',
  '\u00d7\u00d8\u0007\b\u0002\u0002\u00d8\u00d9\u0005\u0004\u0003\u0002',
  '\u00d9\u00da\u0007\u0005\u0002\u0002\u00da1\u0003\u0002\u0002\u0002',
  '\u00db\u00e3\u00054\u001b\u0002\u00dc\u00e3\u00056\u001c\u0002\u00dd',
  '\u00de\u0007\u0017\u0002\u0002\u00de\u00df\u0007\u0004\u0002\u0002\u00df',
  '\u00e0\u00058\u001d\u0002\u00e0\u00e1\u0007\u0005\u0002\u0002\u00e1',
  '\u00e3\u0003\u0002\u0002\u0002\u00e2\u00db\u0003\u0002\u0002\u0002\u00e2',
  '\u00dc\u0003\u0002\u0002\u0002\u00e2\u00dd\u0003\u0002\u0002\u0002\u00e3',
  '3\u0003\u0002\u0002\u0002\u00e4\u00e5\t\u0005\u0002\u0002\u00e5\u00e6',
  '\u0007\u0004\u0002\u0002\u00e6\u00e7\u0005\u0004\u0003\u0002\u00e7\u00e8',
  '\u0007\b\u0002\u0002\u00e8\u00e9\u0005\u0004\u0003\u0002\u00e9\u00ea',
  '\u0007\u0005\u0002\u0002\u00ea5\u0003\u0002\u0002\u0002\u00eb\u00ec',
  '\t\u0006\u0002\u0002\u00ec\u00ed\u0007\u0004\u0002\u0002\u00ed\u00ee',
  '\u0005\u000e\b\u0002\u00ee\u00ef\u0007\b\u0002\u0002\u00ef\u00f0\u0005',
  '\u000e\b\u0002\u00f0\u00f1\u0007\u0005\u0002\u0002\u00f17\u0003\u0002',
  '\u0002\u0002\u00f2\u00f3\u0007 \u0002\u0002\u00f39\u0003\u0002\u0002',
  '\u0002\u00f4\u00f5\u0007!\u0002\u0002\u00f5;\u0003\u0002\u0002\u0002',
  '\u00f6\u00f7\u0007"\u0002\u0002\u00f7=\u0003\u0002\u0002\u0002\u00f8',
  '\u00f9\u0007#\u0002\u0002\u00f9?\u0003\u0002\u0002\u0002\u000bBKOVa',
  'mqw\u00e2',
].join('');

var atn = new antlr4.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map(function (ds, index) {
  return new antlr4.DFA(ds, index);
});

var sharedContextCache = new antlr4.PredictionContextCache();

var literalNames = [
  null,
  "'+'",
  "'('",
  "')'",
  "'RightPad'",
  "'LeftPad'",
  "','",
  "'DateTimeFormat'",
  "'ConvertSidToString'",
  "'ReplaceString'",
  "'Word'",
  "'Left'",
  "'Right'",
  "'Mid'",
  "'CRLF'",
  "'BitAnd'",
  "'BitOr'",
  "'RandomNum'",
  "'ConvertStringToGuid'",
  "'Null'",
  "'IIF'",
  "'IsPresent'",
  "'Eq'",
  "'NotEquals'",
  "'LessThan'",
  "'GreaterThan'",
  "'LessThanOrEquals'",
  "'GreaterThanOrEquals'",
];

var symbolicNames = [
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  'WS',
  'UnaryStringFunctionName',
  'QNAME',
  'NUMBER',
  'HEX',
  'STRING',
];

var ruleNames = [
  'start',
  'anyType',
  'stringType',
  'stringTypeNoConcat',
  'stringFunction',
  'stringConcatenation',
  'intType',
  'intFunction',
  'byteArrayType',
  'byteArrayFunction',
  'unaryStringFunction',
  'fnPadString',
  'fnDateTimeFormat',
  'fnConvertSidToString',
  'fnReplaceString',
  'fnWord',
  'fnLeftRight',
  'fnMid',
  'fnCRLF',
  'fnBitInt',
  'fnRandomNum',
  'fnConvertStringToGuid',
  'fnNull',
  'fnIIF',
  'condition',
  'conditionAny',
  'conditionNumeric',
  'attribute',
  'number',
  'hex',
  'string',
];

class customExpressionParser extends antlr4.Parser {
  constructor(input) {
    super(input);
    this._interp = new antlr4.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
    this.ruleNames = ruleNames;
    this.literalNames = literalNames;
    this.symbolicNames = symbolicNames;
  }

  get atn() {
    return atn;
  }
}

customExpressionParser.EOF = antlr4.Token.EOF;
customExpressionParser.T__0 = 1;
customExpressionParser.T__1 = 2;
customExpressionParser.T__2 = 3;
customExpressionParser.T__3 = 4;
customExpressionParser.T__4 = 5;
customExpressionParser.T__5 = 6;
customExpressionParser.T__6 = 7;
customExpressionParser.T__7 = 8;
customExpressionParser.T__8 = 9;
customExpressionParser.T__9 = 10;
customExpressionParser.T__10 = 11;
customExpressionParser.T__11 = 12;
customExpressionParser.T__12 = 13;
customExpressionParser.T__13 = 14;
customExpressionParser.T__14 = 15;
customExpressionParser.T__15 = 16;
customExpressionParser.T__16 = 17;
customExpressionParser.T__17 = 18;
customExpressionParser.T__18 = 19;
customExpressionParser.T__19 = 20;
customExpressionParser.T__20 = 21;
customExpressionParser.T__21 = 22;
customExpressionParser.T__22 = 23;
customExpressionParser.T__23 = 24;
customExpressionParser.T__24 = 25;
customExpressionParser.T__25 = 26;
customExpressionParser.T__26 = 27;
customExpressionParser.WS = 28;
customExpressionParser.UnaryStringFunctionName = 29;
customExpressionParser.QNAME = 30;
customExpressionParser.NUMBER = 31;
customExpressionParser.HEX = 32;
customExpressionParser.STRING = 33;

customExpressionParser.RULE_start = 0;
customExpressionParser.RULE_anyType = 1;
customExpressionParser.RULE_stringType = 2;
customExpressionParser.RULE_stringTypeNoConcat = 3;
customExpressionParser.RULE_stringFunction = 4;
customExpressionParser.RULE_stringConcatenation = 5;
customExpressionParser.RULE_intType = 6;
customExpressionParser.RULE_intFunction = 7;
customExpressionParser.RULE_byteArrayType = 8;
customExpressionParser.RULE_byteArrayFunction = 9;
customExpressionParser.RULE_unaryStringFunction = 10;
customExpressionParser.RULE_fnPadString = 11;
customExpressionParser.RULE_fnDateTimeFormat = 12;
customExpressionParser.RULE_fnConvertSidToString = 13;
customExpressionParser.RULE_fnReplaceString = 14;
customExpressionParser.RULE_fnWord = 15;
customExpressionParser.RULE_fnLeftRight = 16;
customExpressionParser.RULE_fnMid = 17;
customExpressionParser.RULE_fnCRLF = 18;
customExpressionParser.RULE_fnBitInt = 19;
customExpressionParser.RULE_fnRandomNum = 20;
customExpressionParser.RULE_fnConvertStringToGuid = 21;
customExpressionParser.RULE_fnNull = 22;
customExpressionParser.RULE_fnIIF = 23;
customExpressionParser.RULE_condition = 24;
customExpressionParser.RULE_conditionAny = 25;
customExpressionParser.RULE_conditionNumeric = 26;
customExpressionParser.RULE_attribute = 27;
customExpressionParser.RULE_number = 28;
customExpressionParser.RULE_hex = 29;
customExpressionParser.RULE_string = 30;

class StartContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_start;
  }
}

StartContext.prototype.EOF = function () {
  return this.getToken(customExpressionParser.EOF, 0);
};

StartContext.prototype.anyType = function () {
  return this.getTypedRuleContext(AnyTypeContext, 0);
};

StartContext.prototype.condition = function () {
  return this.getTypedRuleContext(ConditionContext, 0);
};

StartContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitStart(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.StartContext = StartContext;

customExpressionParser.prototype.start = function () {
  var localctx = new StartContext(this, this._ctx, this.state);
  this.enterRule(localctx, 0, customExpressionParser.RULE_start);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 64;
    this._errHandler.sync(this);
    switch (this._input.LA(1)) {
      case customExpressionParser.T__3:
      case customExpressionParser.T__4:
      case customExpressionParser.T__6:
      case customExpressionParser.T__7:
      case customExpressionParser.T__8:
      case customExpressionParser.T__9:
      case customExpressionParser.T__10:
      case customExpressionParser.T__11:
      case customExpressionParser.T__12:
      case customExpressionParser.T__13:
      case customExpressionParser.T__14:
      case customExpressionParser.T__15:
      case customExpressionParser.T__16:
      case customExpressionParser.T__17:
      case customExpressionParser.T__18:
      case customExpressionParser.T__19:
      case customExpressionParser.UnaryStringFunctionName:
      case customExpressionParser.QNAME:
      case customExpressionParser.NUMBER:
      case customExpressionParser.HEX:
      case customExpressionParser.STRING:
        this.state = 62;
        this.anyType();
        break;
      case customExpressionParser.T__20:
      case customExpressionParser.T__21:
      case customExpressionParser.T__22:
      case customExpressionParser.T__23:
      case customExpressionParser.T__24:
      case customExpressionParser.T__25:
      case customExpressionParser.T__26:
        this.state = 63;
        this.condition();
        break;
      default:
        throw new antlr4.error.NoViableAltException(this);
    }
    this.state = 66;
    this.match(customExpressionParser.EOF);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class AnyTypeContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_anyType;
  }
}

AnyTypeContext.prototype.fnNull = function () {
  return this.getTypedRuleContext(FnNullContext, 0);
};

AnyTypeContext.prototype.fnIIF = function () {
  return this.getTypedRuleContext(FnIIFContext, 0);
};

AnyTypeContext.prototype.stringType = function () {
  return this.getTypedRuleContext(StringTypeContext, 0);
};

AnyTypeContext.prototype.intType = function () {
  return this.getTypedRuleContext(IntTypeContext, 0);
};

AnyTypeContext.prototype.byteArrayType = function () {
  return this.getTypedRuleContext(ByteArrayTypeContext, 0);
};

AnyTypeContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitAnyType(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.AnyTypeContext = AnyTypeContext;

customExpressionParser.prototype.anyType = function () {
  var localctx = new AnyTypeContext(this, this._ctx, this.state);
  this.enterRule(localctx, 2, customExpressionParser.RULE_anyType);
  try {
    this.state = 73;
    this._errHandler.sync(this);
    var la_ = this._interp.adaptivePredict(this._input, 1, this._ctx);
    switch (la_) {
      case 1:
        this.enterOuterAlt(localctx, 1);
        this.state = 68;
        this.fnNull();
        break;

      case 2:
        this.enterOuterAlt(localctx, 2);
        this.state = 69;
        this.fnIIF();
        break;

      case 3:
        this.enterOuterAlt(localctx, 3);
        this.state = 70;
        this.stringType();
        break;

      case 4:
        this.enterOuterAlt(localctx, 4);
        this.state = 71;
        this.intType();
        break;

      case 5:
        this.enterOuterAlt(localctx, 5);
        this.state = 72;
        this.byteArrayType();
        break;
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class StringTypeContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_stringType;
  }
}

StringTypeContext.prototype.stringTypeNoConcat = function () {
  return this.getTypedRuleContext(StringTypeNoConcatContext, 0);
};

StringTypeContext.prototype.stringConcatenation = function () {
  return this.getTypedRuleContext(StringConcatenationContext, 0);
};

StringTypeContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitStringType(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.StringTypeContext = StringTypeContext;

customExpressionParser.prototype.stringType = function () {
  var localctx = new StringTypeContext(this, this._ctx, this.state);
  this.enterRule(localctx, 4, customExpressionParser.RULE_stringType);
  try {
    this.state = 77;
    this._errHandler.sync(this);
    var la_ = this._interp.adaptivePredict(this._input, 2, this._ctx);
    switch (la_) {
      case 1:
        this.enterOuterAlt(localctx, 1);
        this.state = 75;
        this.stringTypeNoConcat();
        break;

      case 2:
        this.enterOuterAlt(localctx, 2);
        this.state = 76;
        this.stringConcatenation();
        break;
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class StringTypeNoConcatContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_stringTypeNoConcat;
  }
}

StringTypeNoConcatContext.prototype.string = function () {
  return this.getTypedRuleContext(StringContext, 0);
};

StringTypeNoConcatContext.prototype.stringFunction = function () {
  return this.getTypedRuleContext(StringFunctionContext, 0);
};

StringTypeNoConcatContext.prototype.attribute = function () {
  return this.getTypedRuleContext(AttributeContext, 0);
};

StringTypeNoConcatContext.prototype.fnIIF = function () {
  return this.getTypedRuleContext(FnIIFContext, 0);
};

StringTypeNoConcatContext.prototype.fnNull = function () {
  return this.getTypedRuleContext(FnNullContext, 0);
};

StringTypeNoConcatContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitStringTypeNoConcat(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.StringTypeNoConcatContext = StringTypeNoConcatContext;

customExpressionParser.prototype.stringTypeNoConcat = function () {
  var localctx = new StringTypeNoConcatContext(this, this._ctx, this.state);
  this.enterRule(localctx, 6, customExpressionParser.RULE_stringTypeNoConcat);
  try {
    this.state = 84;
    this._errHandler.sync(this);
    switch (this._input.LA(1)) {
      case customExpressionParser.STRING:
        this.enterOuterAlt(localctx, 1);
        this.state = 79;
        this.string();
        break;
      case customExpressionParser.T__3:
      case customExpressionParser.T__4:
      case customExpressionParser.T__6:
      case customExpressionParser.T__7:
      case customExpressionParser.T__8:
      case customExpressionParser.T__9:
      case customExpressionParser.T__10:
      case customExpressionParser.T__11:
      case customExpressionParser.T__12:
      case customExpressionParser.T__13:
      case customExpressionParser.UnaryStringFunctionName:
        this.enterOuterAlt(localctx, 2);
        this.state = 80;
        this.stringFunction();
        break;
      case customExpressionParser.QNAME:
        this.enterOuterAlt(localctx, 3);
        this.state = 81;
        this.attribute();
        break;
      case customExpressionParser.T__19:
        this.enterOuterAlt(localctx, 4);
        this.state = 82;
        this.fnIIF();
        break;
      case customExpressionParser.T__18:
        this.enterOuterAlt(localctx, 5);
        this.state = 83;
        this.fnNull();
        break;
      default:
        throw new antlr4.error.NoViableAltException(this);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class StringFunctionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_stringFunction;
  }
}

StringFunctionContext.prototype.unaryStringFunction = function () {
  return this.getTypedRuleContext(UnaryStringFunctionContext, 0);
};

StringFunctionContext.prototype.fnPadString = function () {
  return this.getTypedRuleContext(FnPadStringContext, 0);
};

StringFunctionContext.prototype.fnDateTimeFormat = function () {
  return this.getTypedRuleContext(FnDateTimeFormatContext, 0);
};

StringFunctionContext.prototype.fnConvertSidToString = function () {
  return this.getTypedRuleContext(FnConvertSidToStringContext, 0);
};

StringFunctionContext.prototype.fnReplaceString = function () {
  return this.getTypedRuleContext(FnReplaceStringContext, 0);
};

StringFunctionContext.prototype.fnWord = function () {
  return this.getTypedRuleContext(FnWordContext, 0);
};

StringFunctionContext.prototype.fnLeftRight = function () {
  return this.getTypedRuleContext(FnLeftRightContext, 0);
};

StringFunctionContext.prototype.fnMid = function () {
  return this.getTypedRuleContext(FnMidContext, 0);
};

StringFunctionContext.prototype.fnCRLF = function () {
  return this.getTypedRuleContext(FnCRLFContext, 0);
};

StringFunctionContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitStringFunction(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.StringFunctionContext = StringFunctionContext;

customExpressionParser.prototype.stringFunction = function () {
  var localctx = new StringFunctionContext(this, this._ctx, this.state);
  this.enterRule(localctx, 8, customExpressionParser.RULE_stringFunction);
  try {
    this.state = 95;
    this._errHandler.sync(this);
    switch (this._input.LA(1)) {
      case customExpressionParser.UnaryStringFunctionName:
        this.enterOuterAlt(localctx, 1);
        this.state = 86;
        this.unaryStringFunction();
        break;
      case customExpressionParser.T__3:
      case customExpressionParser.T__4:
        this.enterOuterAlt(localctx, 2);
        this.state = 87;
        this.fnPadString();
        break;
      case customExpressionParser.T__6:
        this.enterOuterAlt(localctx, 3);
        this.state = 88;
        this.fnDateTimeFormat();
        break;
      case customExpressionParser.T__7:
        this.enterOuterAlt(localctx, 4);
        this.state = 89;
        this.fnConvertSidToString();
        break;
      case customExpressionParser.T__8:
        this.enterOuterAlt(localctx, 5);
        this.state = 90;
        this.fnReplaceString();
        break;
      case customExpressionParser.T__9:
        this.enterOuterAlt(localctx, 6);
        this.state = 91;
        this.fnWord();
        break;
      case customExpressionParser.T__10:
      case customExpressionParser.T__11:
        this.enterOuterAlt(localctx, 7);
        this.state = 92;
        this.fnLeftRight();
        break;
      case customExpressionParser.T__12:
        this.enterOuterAlt(localctx, 8);
        this.state = 93;
        this.fnMid();
        break;
      case customExpressionParser.T__13:
        this.enterOuterAlt(localctx, 9);
        this.state = 94;
        this.fnCRLF();
        break;
      default:
        throw new antlr4.error.NoViableAltException(this);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class StringConcatenationContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_stringConcatenation;
  }
}

StringConcatenationContext.prototype.stringTypeNoConcat = function () {
  return this.getTypedRuleContext(StringTypeNoConcatContext, 0);
};

StringConcatenationContext.prototype.stringType = function () {
  return this.getTypedRuleContext(StringTypeContext, 0);
};

StringConcatenationContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitStringConcatenation(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.StringConcatenationContext = StringConcatenationContext;

customExpressionParser.prototype.stringConcatenation = function () {
  var localctx = new StringConcatenationContext(this, this._ctx, this.state);
  this.enterRule(localctx, 10, customExpressionParser.RULE_stringConcatenation);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 97;
    this.stringTypeNoConcat();
    this.state = 98;
    this.match(customExpressionParser.T__0);
    this.state = 99;
    this.stringType();
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class IntTypeContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_intType;
  }
}

IntTypeContext.prototype.number = function () {
  return this.getTypedRuleContext(NumberContext, 0);
};

IntTypeContext.prototype.hex = function () {
  return this.getTypedRuleContext(HexContext, 0);
};

IntTypeContext.prototype.intFunction = function () {
  return this.getTypedRuleContext(IntFunctionContext, 0);
};

IntTypeContext.prototype.attribute = function () {
  return this.getTypedRuleContext(AttributeContext, 0);
};

IntTypeContext.prototype.fnIIF = function () {
  return this.getTypedRuleContext(FnIIFContext, 0);
};

IntTypeContext.prototype.fnNull = function () {
  return this.getTypedRuleContext(FnNullContext, 0);
};

IntTypeContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitIntType(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.IntTypeContext = IntTypeContext;

customExpressionParser.prototype.intType = function () {
  var localctx = new IntTypeContext(this, this._ctx, this.state);
  this.enterRule(localctx, 12, customExpressionParser.RULE_intType);
  try {
    this.state = 107;
    this._errHandler.sync(this);
    switch (this._input.LA(1)) {
      case customExpressionParser.NUMBER:
        this.enterOuterAlt(localctx, 1);
        this.state = 101;
        this.number();
        break;
      case customExpressionParser.HEX:
        this.enterOuterAlt(localctx, 2);
        this.state = 102;
        this.hex();
        break;
      case customExpressionParser.T__14:
      case customExpressionParser.T__15:
      case customExpressionParser.T__16:
        this.enterOuterAlt(localctx, 3);
        this.state = 103;
        this.intFunction();
        break;
      case customExpressionParser.QNAME:
        this.enterOuterAlt(localctx, 4);
        this.state = 104;
        this.attribute();
        break;
      case customExpressionParser.T__19:
        this.enterOuterAlt(localctx, 5);
        this.state = 105;
        this.fnIIF();
        break;
      case customExpressionParser.T__18:
        this.enterOuterAlt(localctx, 6);
        this.state = 106;
        this.fnNull();
        break;
      default:
        throw new antlr4.error.NoViableAltException(this);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class IntFunctionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_intFunction;
  }
}

IntFunctionContext.prototype.fnBitInt = function () {
  return this.getTypedRuleContext(FnBitIntContext, 0);
};

IntFunctionContext.prototype.fnRandomNum = function () {
  return this.getTypedRuleContext(FnRandomNumContext, 0);
};

IntFunctionContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitIntFunction(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.IntFunctionContext = IntFunctionContext;

customExpressionParser.prototype.intFunction = function () {
  var localctx = new IntFunctionContext(this, this._ctx, this.state);
  this.enterRule(localctx, 14, customExpressionParser.RULE_intFunction);
  try {
    this.state = 111;
    this._errHandler.sync(this);
    switch (this._input.LA(1)) {
      case customExpressionParser.T__14:
      case customExpressionParser.T__15:
        this.enterOuterAlt(localctx, 1);
        this.state = 109;
        this.fnBitInt();
        break;
      case customExpressionParser.T__16:
        this.enterOuterAlt(localctx, 2);
        this.state = 110;
        this.fnRandomNum();
        break;
      default:
        throw new antlr4.error.NoViableAltException(this);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class ByteArrayTypeContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_byteArrayType;
  }
}

ByteArrayTypeContext.prototype.byteArrayFunction = function () {
  return this.getTypedRuleContext(ByteArrayFunctionContext, 0);
};

ByteArrayTypeContext.prototype.attribute = function () {
  return this.getTypedRuleContext(AttributeContext, 0);
};

ByteArrayTypeContext.prototype.fnIIF = function () {
  return this.getTypedRuleContext(FnIIFContext, 0);
};

ByteArrayTypeContext.prototype.fnNull = function () {
  return this.getTypedRuleContext(FnNullContext, 0);
};

ByteArrayTypeContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitByteArrayType(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.ByteArrayTypeContext = ByteArrayTypeContext;

customExpressionParser.prototype.byteArrayType = function () {
  var localctx = new ByteArrayTypeContext(this, this._ctx, this.state);
  this.enterRule(localctx, 16, customExpressionParser.RULE_byteArrayType);
  try {
    this.state = 117;
    this._errHandler.sync(this);
    switch (this._input.LA(1)) {
      case customExpressionParser.T__17:
        this.enterOuterAlt(localctx, 1);
        this.state = 113;
        this.byteArrayFunction();
        break;
      case customExpressionParser.QNAME:
        this.enterOuterAlt(localctx, 2);
        this.state = 114;
        this.attribute();
        break;
      case customExpressionParser.T__19:
        this.enterOuterAlt(localctx, 3);
        this.state = 115;
        this.fnIIF();
        break;
      case customExpressionParser.T__18:
        this.enterOuterAlt(localctx, 4);
        this.state = 116;
        this.fnNull();
        break;
      default:
        throw new antlr4.error.NoViableAltException(this);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class ByteArrayFunctionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_byteArrayFunction;
  }
}

ByteArrayFunctionContext.prototype.fnConvertStringToGuid = function () {
  return this.getTypedRuleContext(FnConvertStringToGuidContext, 0);
};

ByteArrayFunctionContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitByteArrayFunction(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.ByteArrayFunctionContext = ByteArrayFunctionContext;

customExpressionParser.prototype.byteArrayFunction = function () {
  var localctx = new ByteArrayFunctionContext(this, this._ctx, this.state);
  this.enterRule(localctx, 18, customExpressionParser.RULE_byteArrayFunction);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 119;
    this.fnConvertStringToGuid();
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class UnaryStringFunctionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_unaryStringFunction;
  }
}

UnaryStringFunctionContext.prototype.UnaryStringFunctionName = function () {
  return this.getToken(customExpressionParser.UnaryStringFunctionName, 0);
};

UnaryStringFunctionContext.prototype.stringType = function () {
  return this.getTypedRuleContext(StringTypeContext, 0);
};

UnaryStringFunctionContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitUnaryStringFunction(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.UnaryStringFunctionContext = UnaryStringFunctionContext;

customExpressionParser.prototype.unaryStringFunction = function () {
  var localctx = new UnaryStringFunctionContext(this, this._ctx, this.state);
  this.enterRule(localctx, 20, customExpressionParser.RULE_unaryStringFunction);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 121;
    this.match(customExpressionParser.UnaryStringFunctionName);
    this.state = 122;
    this.match(customExpressionParser.T__1);
    this.state = 123;
    this.stringType();
    this.state = 124;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class FnPadStringContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_fnPadString;
  }
}

FnPadStringContext.prototype.stringType = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(StringTypeContext);
  } else {
    return this.getTypedRuleContext(StringTypeContext, i);
  }
};

FnPadStringContext.prototype.intType = function () {
  return this.getTypedRuleContext(IntTypeContext, 0);
};

FnPadStringContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitFnPadString(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.FnPadStringContext = FnPadStringContext;

customExpressionParser.prototype.fnPadString = function () {
  var localctx = new FnPadStringContext(this, this._ctx, this.state);
  this.enterRule(localctx, 22, customExpressionParser.RULE_fnPadString);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 126;
    _la = this._input.LA(1);
    if (!(_la === customExpressionParser.T__3 || _la === customExpressionParser.T__4)) {
      this._errHandler.recoverInline(this);
    } else {
      this._errHandler.reportMatch(this);
      this.consume();
    }
    this.state = 127;
    this.match(customExpressionParser.T__1);
    this.state = 128;
    this.stringType();
    this.state = 129;
    this.match(customExpressionParser.T__5);
    this.state = 130;
    this.intType();
    this.state = 131;
    this.match(customExpressionParser.T__5);
    this.state = 132;
    this.stringType();
    this.state = 133;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class FnDateTimeFormatContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_fnDateTimeFormat;
  }
}

FnDateTimeFormatContext.prototype.stringType = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(StringTypeContext);
  } else {
    return this.getTypedRuleContext(StringTypeContext, i);
  }
};

FnDateTimeFormatContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitFnDateTimeFormat(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.FnDateTimeFormatContext = FnDateTimeFormatContext;

customExpressionParser.prototype.fnDateTimeFormat = function () {
  var localctx = new FnDateTimeFormatContext(this, this._ctx, this.state);
  this.enterRule(localctx, 24, customExpressionParser.RULE_fnDateTimeFormat);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 135;
    this.match(customExpressionParser.T__6);
    this.state = 136;
    this.match(customExpressionParser.T__1);
    this.state = 137;
    this.stringType();
    this.state = 138;
    this.match(customExpressionParser.T__5);
    this.state = 139;
    this.stringType();
    this.state = 140;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class FnConvertSidToStringContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_fnConvertSidToString;
  }
}

FnConvertSidToStringContext.prototype.byteArrayType = function () {
  return this.getTypedRuleContext(ByteArrayTypeContext, 0);
};

FnConvertSidToStringContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitFnConvertSidToString(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.FnConvertSidToStringContext = FnConvertSidToStringContext;

customExpressionParser.prototype.fnConvertSidToString = function () {
  var localctx = new FnConvertSidToStringContext(this, this._ctx, this.state);
  this.enterRule(localctx, 26, customExpressionParser.RULE_fnConvertSidToString);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 142;
    this.match(customExpressionParser.T__7);
    this.state = 143;
    this.match(customExpressionParser.T__1);
    this.state = 144;
    this.byteArrayType();
    this.state = 145;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class FnReplaceStringContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_fnReplaceString;
  }
}

FnReplaceStringContext.prototype.stringType = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(StringTypeContext);
  } else {
    return this.getTypedRuleContext(StringTypeContext, i);
  }
};

FnReplaceStringContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitFnReplaceString(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.FnReplaceStringContext = FnReplaceStringContext;

customExpressionParser.prototype.fnReplaceString = function () {
  var localctx = new FnReplaceStringContext(this, this._ctx, this.state);
  this.enterRule(localctx, 28, customExpressionParser.RULE_fnReplaceString);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 147;
    this.match(customExpressionParser.T__8);
    this.state = 148;
    this.match(customExpressionParser.T__1);
    this.state = 149;
    this.stringType();
    this.state = 150;
    this.match(customExpressionParser.T__5);
    this.state = 151;
    this.stringType();
    this.state = 152;
    this.match(customExpressionParser.T__5);
    this.state = 153;
    this.stringType();
    this.state = 154;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class FnWordContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_fnWord;
  }
}

FnWordContext.prototype.stringType = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(StringTypeContext);
  } else {
    return this.getTypedRuleContext(StringTypeContext, i);
  }
};

FnWordContext.prototype.intType = function () {
  return this.getTypedRuleContext(IntTypeContext, 0);
};

FnWordContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitFnWord(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.FnWordContext = FnWordContext;

customExpressionParser.prototype.fnWord = function () {
  var localctx = new FnWordContext(this, this._ctx, this.state);
  this.enterRule(localctx, 30, customExpressionParser.RULE_fnWord);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 156;
    this.match(customExpressionParser.T__9);
    this.state = 157;
    this.match(customExpressionParser.T__1);
    this.state = 158;
    this.stringType();
    this.state = 159;
    this.match(customExpressionParser.T__5);
    this.state = 160;
    this.intType();
    this.state = 161;
    this.match(customExpressionParser.T__5);
    this.state = 162;
    this.stringType();
    this.state = 163;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class FnLeftRightContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_fnLeftRight;
  }
}

FnLeftRightContext.prototype.stringType = function () {
  return this.getTypedRuleContext(StringTypeContext, 0);
};

FnLeftRightContext.prototype.intType = function () {
  return this.getTypedRuleContext(IntTypeContext, 0);
};

FnLeftRightContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitFnLeftRight(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.FnLeftRightContext = FnLeftRightContext;

customExpressionParser.prototype.fnLeftRight = function () {
  var localctx = new FnLeftRightContext(this, this._ctx, this.state);
  this.enterRule(localctx, 32, customExpressionParser.RULE_fnLeftRight);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 165;
    _la = this._input.LA(1);
    if (!(_la === customExpressionParser.T__10 || _la === customExpressionParser.T__11)) {
      this._errHandler.recoverInline(this);
    } else {
      this._errHandler.reportMatch(this);
      this.consume();
    }
    this.state = 166;
    this.match(customExpressionParser.T__1);
    this.state = 167;
    this.stringType();
    this.state = 168;
    this.match(customExpressionParser.T__5);
    this.state = 169;
    this.intType();
    this.state = 170;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class FnMidContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_fnMid;
  }
}

FnMidContext.prototype.stringType = function () {
  return this.getTypedRuleContext(StringTypeContext, 0);
};

FnMidContext.prototype.intType = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(IntTypeContext);
  } else {
    return this.getTypedRuleContext(IntTypeContext, i);
  }
};

FnMidContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitFnMid(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.FnMidContext = FnMidContext;

customExpressionParser.prototype.fnMid = function () {
  var localctx = new FnMidContext(this, this._ctx, this.state);
  this.enterRule(localctx, 34, customExpressionParser.RULE_fnMid);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 172;
    this.match(customExpressionParser.T__12);
    this.state = 173;
    this.match(customExpressionParser.T__1);
    this.state = 174;
    this.stringType();
    this.state = 175;
    this.match(customExpressionParser.T__5);
    this.state = 176;
    this.intType();
    this.state = 177;
    this.match(customExpressionParser.T__5);
    this.state = 178;
    this.intType();
    this.state = 179;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class FnCRLFContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_fnCRLF;
  }
}

FnCRLFContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitFnCRLF(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.FnCRLFContext = FnCRLFContext;

customExpressionParser.prototype.fnCRLF = function () {
  var localctx = new FnCRLFContext(this, this._ctx, this.state);
  this.enterRule(localctx, 36, customExpressionParser.RULE_fnCRLF);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 181;
    this.match(customExpressionParser.T__13);
    this.state = 182;
    this.match(customExpressionParser.T__1);
    this.state = 183;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class FnBitIntContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_fnBitInt;
  }
}

FnBitIntContext.prototype.intType = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(IntTypeContext);
  } else {
    return this.getTypedRuleContext(IntTypeContext, i);
  }
};

FnBitIntContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitFnBitInt(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.FnBitIntContext = FnBitIntContext;

customExpressionParser.prototype.fnBitInt = function () {
  var localctx = new FnBitIntContext(this, this._ctx, this.state);
  this.enterRule(localctx, 38, customExpressionParser.RULE_fnBitInt);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 185;
    _la = this._input.LA(1);
    if (!(_la === customExpressionParser.T__14 || _la === customExpressionParser.T__15)) {
      this._errHandler.recoverInline(this);
    } else {
      this._errHandler.reportMatch(this);
      this.consume();
    }
    this.state = 186;
    this.match(customExpressionParser.T__1);
    this.state = 187;
    this.intType();
    this.state = 188;
    this.match(customExpressionParser.T__5);
    this.state = 189;
    this.intType();
    this.state = 190;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class FnRandomNumContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_fnRandomNum;
  }
}

FnRandomNumContext.prototype.intType = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(IntTypeContext);
  } else {
    return this.getTypedRuleContext(IntTypeContext, i);
  }
};

FnRandomNumContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitFnRandomNum(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.FnRandomNumContext = FnRandomNumContext;

customExpressionParser.prototype.fnRandomNum = function () {
  var localctx = new FnRandomNumContext(this, this._ctx, this.state);
  this.enterRule(localctx, 40, customExpressionParser.RULE_fnRandomNum);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 192;
    this.match(customExpressionParser.T__16);
    this.state = 193;
    this.match(customExpressionParser.T__1);
    this.state = 194;
    this.intType();
    this.state = 195;
    this.match(customExpressionParser.T__5);
    this.state = 196;
    this.intType();
    this.state = 197;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class FnConvertStringToGuidContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_fnConvertStringToGuid;
  }
}

FnConvertStringToGuidContext.prototype.stringType = function () {
  return this.getTypedRuleContext(StringTypeContext, 0);
};

FnConvertStringToGuidContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitFnConvertStringToGuid(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.FnConvertStringToGuidContext = FnConvertStringToGuidContext;

customExpressionParser.prototype.fnConvertStringToGuid = function () {
  var localctx = new FnConvertStringToGuidContext(this, this._ctx, this.state);
  this.enterRule(localctx, 42, customExpressionParser.RULE_fnConvertStringToGuid);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 199;
    this.match(customExpressionParser.T__17);
    this.state = 200;
    this.match(customExpressionParser.T__1);
    this.state = 201;
    this.stringType();
    this.state = 202;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class FnNullContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_fnNull;
  }
}

FnNullContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitFnNull(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.FnNullContext = FnNullContext;

customExpressionParser.prototype.fnNull = function () {
  var localctx = new FnNullContext(this, this._ctx, this.state);
  this.enterRule(localctx, 44, customExpressionParser.RULE_fnNull);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 204;
    this.match(customExpressionParser.T__18);
    this.state = 205;
    this.match(customExpressionParser.T__1);
    this.state = 206;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class FnIIFContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_fnIIF;
  }
}

FnIIFContext.prototype.condition = function () {
  return this.getTypedRuleContext(ConditionContext, 0);
};

FnIIFContext.prototype.anyType = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(AnyTypeContext);
  } else {
    return this.getTypedRuleContext(AnyTypeContext, i);
  }
};

FnIIFContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitFnIIF(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.FnIIFContext = FnIIFContext;

customExpressionParser.prototype.fnIIF = function () {
  var localctx = new FnIIFContext(this, this._ctx, this.state);
  this.enterRule(localctx, 46, customExpressionParser.RULE_fnIIF);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 208;
    this.match(customExpressionParser.T__19);
    this.state = 209;
    this.match(customExpressionParser.T__1);
    this.state = 210;
    this.condition();
    this.state = 211;
    this.match(customExpressionParser.T__5);
    this.state = 212;
    this.anyType();
    this.state = 213;
    this.match(customExpressionParser.T__5);
    this.state = 214;
    this.anyType();
    this.state = 215;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class ConditionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_condition;
  }
}

ConditionContext.prototype.conditionAny = function () {
  return this.getTypedRuleContext(ConditionAnyContext, 0);
};

ConditionContext.prototype.conditionNumeric = function () {
  return this.getTypedRuleContext(ConditionNumericContext, 0);
};

ConditionContext.prototype.attribute = function () {
  return this.getTypedRuleContext(AttributeContext, 0);
};

ConditionContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitCondition(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.ConditionContext = ConditionContext;

customExpressionParser.prototype.condition = function () {
  var localctx = new ConditionContext(this, this._ctx, this.state);
  this.enterRule(localctx, 48, customExpressionParser.RULE_condition);
  try {
    this.state = 224;
    this._errHandler.sync(this);
    switch (this._input.LA(1)) {
      case customExpressionParser.T__21:
      case customExpressionParser.T__22:
        this.enterOuterAlt(localctx, 1);
        this.state = 217;
        this.conditionAny();
        break;
      case customExpressionParser.T__23:
      case customExpressionParser.T__24:
      case customExpressionParser.T__25:
      case customExpressionParser.T__26:
        this.enterOuterAlt(localctx, 2);
        this.state = 218;
        this.conditionNumeric();
        break;
      case customExpressionParser.T__20:
        this.enterOuterAlt(localctx, 3);
        this.state = 219;
        this.match(customExpressionParser.T__20);
        this.state = 220;
        this.match(customExpressionParser.T__1);
        this.state = 221;
        this.attribute();
        this.state = 222;
        this.match(customExpressionParser.T__2);
        break;
      default:
        throw new antlr4.error.NoViableAltException(this);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class ConditionAnyContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_conditionAny;
  }
}

ConditionAnyContext.prototype.anyType = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(AnyTypeContext);
  } else {
    return this.getTypedRuleContext(AnyTypeContext, i);
  }
};

ConditionAnyContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitConditionAny(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.ConditionAnyContext = ConditionAnyContext;

customExpressionParser.prototype.conditionAny = function () {
  var localctx = new ConditionAnyContext(this, this._ctx, this.state);
  this.enterRule(localctx, 50, customExpressionParser.RULE_conditionAny);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 226;
    _la = this._input.LA(1);
    if (!(_la === customExpressionParser.T__21 || _la === customExpressionParser.T__22)) {
      this._errHandler.recoverInline(this);
    } else {
      this._errHandler.reportMatch(this);
      this.consume();
    }
    this.state = 227;
    this.match(customExpressionParser.T__1);
    this.state = 228;
    this.anyType();
    this.state = 229;
    this.match(customExpressionParser.T__5);
    this.state = 230;
    this.anyType();
    this.state = 231;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class ConditionNumericContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_conditionNumeric;
  }
}

ConditionNumericContext.prototype.intType = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(IntTypeContext);
  } else {
    return this.getTypedRuleContext(IntTypeContext, i);
  }
};

ConditionNumericContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitConditionNumeric(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.ConditionNumericContext = ConditionNumericContext;

customExpressionParser.prototype.conditionNumeric = function () {
  var localctx = new ConditionNumericContext(this, this._ctx, this.state);
  this.enterRule(localctx, 52, customExpressionParser.RULE_conditionNumeric);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 233;
    _la = this._input.LA(1);
    if (
      !(
        (_la & ~0x1f) == 0 &&
        ((1 << _la) &
          ((1 << customExpressionParser.T__23) |
            (1 << customExpressionParser.T__24) |
            (1 << customExpressionParser.T__25) |
            (1 << customExpressionParser.T__26))) !==
          0
      )
    ) {
      this._errHandler.recoverInline(this);
    } else {
      this._errHandler.reportMatch(this);
      this.consume();
    }
    this.state = 234;
    this.match(customExpressionParser.T__1);
    this.state = 235;
    this.intType();
    this.state = 236;
    this.match(customExpressionParser.T__5);
    this.state = 237;
    this.intType();
    this.state = 238;
    this.match(customExpressionParser.T__2);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class AttributeContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_attribute;
  }
}

AttributeContext.prototype.QNAME = function () {
  return this.getToken(customExpressionParser.QNAME, 0);
};

AttributeContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitAttribute(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.AttributeContext = AttributeContext;

customExpressionParser.prototype.attribute = function () {
  var localctx = new AttributeContext(this, this._ctx, this.state);
  this.enterRule(localctx, 54, customExpressionParser.RULE_attribute);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 240;
    this.match(customExpressionParser.QNAME);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class NumberContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_number;
  }
}

NumberContext.prototype.NUMBER = function () {
  return this.getToken(customExpressionParser.NUMBER, 0);
};

NumberContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitNumber(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.NumberContext = NumberContext;

customExpressionParser.prototype.number = function () {
  var localctx = new NumberContext(this, this._ctx, this.state);
  this.enterRule(localctx, 56, customExpressionParser.RULE_number);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 242;
    this.match(customExpressionParser.NUMBER);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class HexContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_hex;
  }
}

HexContext.prototype.HEX = function () {
  return this.getToken(customExpressionParser.HEX, 0);
};

HexContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitHex(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.HexContext = HexContext;

customExpressionParser.prototype.hex = function () {
  var localctx = new HexContext(this, this._ctx, this.state);
  this.enterRule(localctx, 58, customExpressionParser.RULE_hex);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 244;
    this.match(customExpressionParser.HEX);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

class StringContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    super(parent, invokingState === undefined || invokingState === null ? -1 : invokingState);
    this.parser = parser;
    this.ruleIndex = customExpressionParser.RULE_string;
  }
}

StringContext.prototype.STRING = function () {
  return this.getToken(customExpressionParser.STRING, 0);
};

StringContext.prototype.accept = function (visitor) {
  if (visitor instanceof customExpressionVisitor) {
    return visitor.visitString(this);
  } else {
    return visitor.visitChildren(this);
  }
};

customExpressionParser.StringContext = StringContext;

customExpressionParser.prototype.string = function () {
  var localctx = new StringContext(this, this._ctx, this.state);
  this.enterRule(localctx, 60, customExpressionParser.RULE_string);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 246;
    this.match(customExpressionParser.STRING);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

export default customExpressionParser;
export { customExpressionParser };
